export default "__VITE_ASSET__loWe1vON__"